import * as actions from './currencyExchange/actions'
import * as mutations from './currencyExchange/mutations'
import * as getters from './currencyExchange/getters'

import { dataProps } from './currencyExchange/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/currencyExchange.js